import { gql } from '@apollo/client';

import {
  APPOINTMENTS_FRAGMENT,
  APPOINTMENT_DATE_FRAGMENT,
  APPOINTMENT_FILE_FRAGMENT,
  APPOINTMENT_ITEM_FRAGMENT
} from './fragments';

export const GET_APPOINTMENTS = gql`
  query Appointments($query: GetAppointmentsInput!) {
    appointmentsForDoctor(query: $query) {
      data {
        results {
          ...Appointment
        }
        total
      }
    }
  }
  ${APPOINTMENTS_FRAGMENT}
`;

export const GET_PATIENT_APPOINTMENTS = gql`
  query PatientAppointments($query: GetAppointmentsInput!) {
    appointmentsForDoctor(query: $query) {
      data {
        results {
          id
          paid
          status
          dates {
            ...AppointmentDateFragment
          }
          plan {
            id
            type
          }
        }
        total
      }
    }
  }
  ${APPOINTMENT_DATE_FRAGMENT}
`;

export const GET_PATIENT_APPOINTMENTS_LINKS = gql`
  query PatientAppointmentsLinks($query: GetAppointmentsInput!) {
    appointmentsForDoctor(query: $query) {
      data {
        results {
          id
          links
        }
        total
      }
    }
  }
`;

export const GET_APPOINTMENT_ITEM = gql`
  query AppointmentById($id: ID!) {
    appointment(id: $id) {
      data {
        ...AppointmentItem
      }
    }
  }
  ${APPOINTMENT_ITEM_FRAGMENT}
`;

export const GET_PREVIOUS_FILES = gql`
  query PreviousFiles($id: ID!) {
    previousFiles(id: $id) {
      data {
        ...AppointmentFileFragment
        appointment_id
      }
    }
  }
  ${APPOINTMENT_FILE_FRAGMENT}
`;

export const GET_PREVIOUS_FILES_PATIENT = gql`
  query PreviousFilesPatient($id: ID!) {
    previousFilesPatient(patientId: $id) {
      data {
        id
        file
        created_at
        appointment_id
      }
    }
  }
`;

export const GET_INVOICE = gql`
  query GetAppointmentInvoice($id: ID!) {
    getAppointmentInvoice(appointment: $id) {
      data {
        id
        created_at
      }
    }
  }
`;

export const GET_APPOINTMENT_BY_CREATOR = gql`
  query AppointmentByCreatorDoctor($query: Pagination!) {
    appointmentByCreatorDoctor(query: $query) {
      data {
        results {
          id
          created_at
          updated_at
          notes {
            id
            note
          }
        }
        total
      }
    }
  }
`;

export const GET_NEAREST_APPOINTMENT = gql`
  query NearestAppointment {
    nearestAppointment {
      data {
        patient {
          avatar
          first_name
          last_name
        }
        date
        id
        appointment_id
        plan {
          name
        }
      }
    }
  }
`;
